import React from 'react';
import './UserCard.css';

/**
 * 用户卡片组件
 * @param {Object} user - 用户信息对象
 * @param {Function} onClick - 点击回调
 */
const UserCard = ({ user, onClick }) => {
  const handleClick = () => {
    onClick(user);
  };

  // 获取头像路径（使用 BASE_URL 确保路径正确）
  const baseUrl = import.meta.env.BASE_URL || '/demo/';
  const portraitPath = `${baseUrl}portrait/user${user.id}.png`;

  return (
    <div className="user-card" onClick={handleClick}>
      <div className="user-card-header">
        <div className="user-avatar">
          <img 
            src={portraitPath} 
            alt={user.name}
            className="avatar-image"
            onError={(e) => {
              // 如果头像加载失败，显示首字母
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
          <span className="avatar-fallback">{user.name.charAt(0)}</span>
        </div>
        <h3 className="user-name">{user.name}</h3>
      </div>
      
      <div className="user-persona">
        <span className="persona-badge">{user.persona}</span>
      </div>
      
      <p className="user-description">{user.description}</p>
      
      <div className="card-hover-overlay">
        <span className="select-text">Click to Select</span>
      </div>
    </div>
  );
};

export default UserCard;

